import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import CampaignRouletteRoutes from "@/pages/crm/campaign-roulette/campaign-roulette.routes";
import GamificationRoutes from "@/pages/crm/gamification/gamification.routes";
import { Gamepad2, PartyPopper } from "lucide-react";
import { createRoute } from "../createRoute";

export const crmRoutes = [
  createRoute({
    id: "Histórico de Campanhas",
    category: "Portal Roleta",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CRM],
    path: "/gestao-campanha-roleta/*",
    pathId: "/crm",
    element: <CampaignRouletteRoutes />,
    Icon: PartyPopper,
  }),
  createRoute({
    id: "Gameficação",
    category: "Portal Gameficação",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CRM],
    path: "/gestao-gameficacao/*",
    pathId: "/crm",
    element: <GamificationRoutes />,
    Icon: Gamepad2,
  }),
];
